<template>
  <span id="loginData" class="flex flex-wrap items-center gap-3 text-base">
    <span class="font-semibold whitespace-nowrap">{{
      userData.name || userData.username
    }}</span>
    <a
      :href="settingsUrl"
      target="_blank"
      rel="noopener"
      class="whitespace-nowrap bg-schneider-petrol-light hover:bg-schneider-petrol-dark text-white text-sm px-3 py-1 rounded-md"
    >
      Passwort ändern
    </a>
    <button
      @click="logout"
      class="whitespace-nowrap bg-schneider-gelb hover:opacity-90 text-schneider-petrol font-bold text-sm px-3 py-1 rounded-md"
      type="button"
    >
      Ausloggen
    </button></span
  >
</template>

<script>
import oidc from "../../auth/oidc";
export default {
  data() {
    return {
      // Authentik-Passwort-ändern-Flow (deutsch + Re-Auth, Blueprint schneider-password-change).
      // Dedizierter Flow-Link statt /if/user/ — external-User (Partner) würden von dort zur App
      // zurück-redirected. Ziel bei Bedarf via VUE_APP_OIDC_BASE überschreibbar.
      settingsUrl:
        (process.env.VUE_APP_OIDC_BASE ||
          "https://auth.next.cloud.dieschneidergruppe.de") +
        "/if/flow/default-password-change/",
    };
  },
  computed: {
    userData() {
      return this.$store.state.userdata;
    },
  },
  methods: {
    logout() {
      oidc.logout(); // beendet die Authentik-Session + redirectet selbst (RP-Logout)
    },
  },
};
</script>

<style>
</style>